import { render, staticRenderFns } from "./Onzehonden_Section.vue?vue&type=template&id=a5e589c0"
import script from "./Onzehonden_Section.vue?vue&type=script&lang=js"
export * from "./Onzehonden_Section.vue?vue&type=script&lang=js"
import style0 from "./Onzehonden_Section.vue?vue&type=style&index=0&id=a5e589c0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports